export const FETCH_HOMEPAGE_REQUEST=`FETCH_HOMEPAGE`;
export const FETCH_HOMEPAGE_SUCCESS=`FETCH_HOMEPAGE_SUCCESS`;
export const FETCH_HOMEPAGE_ERROR=`FETCH_HOMEPAGE_ERROR`;